import React from 'react';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { FFT_CMP_GROUP_SET } from '../../../function/GroupDataModel';
import { GetTrendGroupTableByItemSet } from '../../../function/GroupDataModel';
import SimpleDialog from '../../atoms/Dialog/SimpleDialog';
import TrendGraphGroupSelectPage from '../TrendGraph/TrendGraphGroupSelectPage';
import RealTimeTrendGraphGroupSelectPage from '../RealTimeTrendGraph/RealTimeTrendGraphGroupSelectPage';

import { MeasureInfoType, SelectDataType, FindMeasureInfo } from './RawWaveformComparisonConanair';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);

/**ダイアログ表示モードキー */
const DialogKindKey = {
  None: 'None',
  RealTime: 'realTime',
  Trend: 'trend',
} as const;
/**ダイアログ表示タイプ */
type DialgKindType = typeof DialogKindKey[keyof typeof DialogKindKey];

/**引数 */
type Props = {
  selectDatas: SelectDataType[];
  measureInfo: MeasureInfoType[];
};

const RawWaveformComparisonConanairButtonList: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();

  const { selectDatas, measureInfo } = props;

  const [simpleDialogOpen, setSimpleDialogOpen] = React.useState(false);
  const [fftErrDialogOpen, setFftErrDialogOpen] = React.useState(false);
  const [gropuSelectDialogOpen, setGropuSelectDialogOpen] = React.useState(false);
  const [dialogKind, setDialogKind] = React.useState<DialgKindType>(DialogKindKey.None);
  const [selectGroupNos, setSelectGroupNos] = React.useState<number[]>([]);

  /** FFT比較ボタン処理 */
  const handleFftComparisonPageOpen = () => {
    let plc1: number = 0;
    let plc2: number = 0;
    let time1: string = '';
    let set1: number = 0;
    let set2: number = 0;
    let time2: string = '';

    const sDatas = selectDatas.filter((row) => row.isSelect === true);

    console.debug(['sDatas', sDatas]);
    if (!sDatas) {
      console.debug(['selectData none']);
      setFftErrDialogOpen(true);
      return;
    }
    for (let i = 0; i < sDatas.length; i++) {
      var target = FindMeasureInfo(measureInfo, sDatas[i]);
      if (!target) {
        continue;
      }
      if (i == 0) {
        plc1 = target.PlcNo;
        set1 = target.SetNo;
        if (sDatas[i].selectDate != null) {
          time1 = dayjs(sDatas[i].selectDate).format('YYYY/MM/DD') + ' ' + sDatas[i].selectTime;
        } else {
          time1 = '';
        }
      } else {
        plc2 = target.PlcNo;
        set2 = target.SetNo;
        if (sDatas[i].selectDate != null) {
          time2 = dayjs(sDatas[i].selectDate).format('YYYY/MM/DD') + ' ' + sDatas[i].selectTime;
        } else {
          time2 = '';
        }
      }
    }

    //console.debug(['plc1', plc1, 'plc2', plc2]);
    if (plc1 === 0 && plc2 === 0) {
      console.debug(['selectData none']);
      setFftErrDialogOpen(true);
      return;
    }

    var fftgroupSet: FFT_CMP_GROUP_SET = {
      GROUP_NO: 99,
      GROUP_NAME: '',
      DSP_FLG: 0,
      PLC_NO1: plc1,
      SET_NO1: set1,
      PLC_NO2: plc2,
      SET_NO2: set2,
      PLC_NO3: 0,
      SET_NO3: 0,
      KIND1: 0,
      KIND2: 0,
      KIND3: 0,

      Time_No1: time1,
      Time_No2: time2,
      Time_No3: '',
    };

    console.debug(['passData', fftgroupSet]);

    //画面遷移
    history.push({
      pathname: '/FFTComparisonPage',
      state: fftgroupSet,
    });
  };

  /**
   *傾向管理ボタン処理
   */
  const handleTrendPageOpen = () => {
    const sData = selectDatas.find((row) => row.isSelect === true);
    if (!sData) {
      console.debug(['selectData none']);
      handleSimpleDialogClickOpen();
      return;
    }

    setDialogKind(DialogKindKey.Trend);

    var target = FindMeasureInfo(measureInfo, sData);

    GetTrendGroupTableByItemSet().then((ret) => {
      var gpInfo = ret.filter(
        (row) => row.trdItemSet.PLC_NO == target?.PlcNo && row.trdItemSet.SET_NO === target.SetNo
      );
      console.debug(['getgpItem=', gpInfo]);

      if (gpInfo.length !== 0) {
        var gpNos: number[] = [];
        for (var i in gpInfo) {
          gpNos.push(gpInfo[i].trdGroupSet.GROUP_NO);
        }
        setSelectGroupNos(gpNos);
      } else {
        handleSimpleDialogClickOpen();
        return;
      }
      handleGroupSelectDialogShow();
    });
  };

  /**
   * グループ選択ダイアログ表示
   */
  const handleGroupSelectDialogShow = () => {
    setGropuSelectDialogOpen(true);
  };

  /**
   * グループ選択ダイアログ閉じる
   */
  const handleGroupSelectDialogClose = () => {
    setGropuSelectDialogOpen(false);
  };

  /**
   * メッセージボックス表示
   */
  const handleSimpleDialogClickOpen = () => {
    setSimpleDialogOpen(true);
  };

  /**メッセージボックス閉じる */
  const handleSimpleDialogClose = () => {
    setSimpleDialogOpen(false);
  };
  return (
    <Grid container>
      {/* <Grid item xs={2}>
        <Button
          className={classes.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={handleTrendPageOpen}
        >
          {t('RawWaveformComparisonConanairButtonList.傾向管理', '傾向管理')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          className={classes.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={handleFftComparisonPageOpen}
        >
          {t('RawWaveformComparisonConanairButtonList.FFT比較', 'FFT比較')}
        </Button>
      </Grid> */}
      <SimpleDialog
        open={gropuSelectDialogOpen}
        onClose={handleGroupSelectDialogClose}
        title={t('RawWaveformComparisonConanairButtonList.グループ選択', 'グループ選択')}
        okText={t('RawWaveformComparisonConanairButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        {dialogKind == DialogKindKey.RealTime ? (
          <RealTimeTrendGraphGroupSelectPage defalutGropuNos={selectGroupNos ?? []} />
        ) : (
          <TrendGraphGroupSelectPage defalutGropuNos={selectGroupNos} />
        )}
      </SimpleDialog>
      <SimpleDialog
        open={simpleDialogOpen}
        onClose={handleSimpleDialogClose}
        title={t('RawWaveformComparisonConanairButtonList.グループ選択', 'グループ選択')}
        okText={t('RawWaveformComparisonConanairButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        <Typography>グループが見つかりませんでした</Typography>
      </SimpleDialog>

      <SimpleDialog
        open={fftErrDialogOpen}
        onClose={() => setFftErrDialogOpen(false)}
        title={t('RawWaveformComparisonConanairButtonList.FFT比較', 'FFT比較')}
        okText={t('RawWaveformComparisonConanairButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        <Typography>項目が選択されていません</Typography>
      </SimpleDialog>
    </Grid>
  );
};

export default RawWaveformComparisonConanairButtonList;
